











import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class RenderEmpty extends Vue {
  @Prop({default: "در این بخش محتوایی وجود ندارد"}) private message!: string;
  @Prop({default: "times"}) private icon!: string;
  @Prop({default: true}) private showBorder!: string;

  get emptyBorderClass() {
    if (this.showBorder) {
      return "borders";
    }
    return "";
  }
}
